<template>
  <button @click="showCart = true" class="flex items-center group relative uppercase">
<!--    <img class="w-6 -scale-x-100" src="/img/cart.svg" alt="Cart"/>-->
    <div
        class=" border border-black mr-2  w-5 h-5 flex items-center justify-center text-[13px] -top-2 -right-3 "
        v-if="lineItems && totalQuantity != 0">{{ totalQuantity }}
    </div>
    <span class="group-hover:underline">Cart</span>
  </button>
  <div class="text-black fixed top-0 left-0 w-full h-full bg-black/50  z-20 js--cart-wrapper"
       @click="closeCart"
       v-if="showCart"
  >
    <div
        class="w-full max-h-[90vh] overflow-y-scroll max-w-[500px] bg-white  absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-sm">

      <div class="p-4 relative pt-6">
        <div class="font-title px-3 mb-6 pt-4 pb-3   bg-yellow border border-black text-[28px] leading-none uppercase">
          Cart
        </div>
        <div v-if="loading" class="absolute top-0 left-0 bg-white/80 w-full h-full z-10"></div>
        <div class="pb-2" v-if="lineItems.length === 0">
          Your cart is empty. <a class="underline" href="/shop">Visit the shop</a>.
        </div>
        <div v-else>
          <div v-for="(lineItem, index) in lineItems"
               :class="[index == lineItems.length - 1 ? '' : 'border-b pb-4']"
               class="grid grid-cols-5 gap-x-4 mb-6">
            <div class="col-span-1">
              <img :src="lineItem.variant.image.src" :alt="lineItem.title" class="w-full">
            </div>
            <div class="col-span-4 flex justify-between items-start">
              <div class="h-full flex flex-col justify-between">
                <div>
                  <div class="font-title leading-none font-semibold text-[22px]">{{ lineItem.title }}</div>
                  <div v-if="lineItem.variant.title != 'Default Title'" class="leading-tight text-[14px]">
                    {{ lineItem.variant.title }}
                  </div>
                </div>
                <div class="font-light">{{ formatCurrency.format(lineItem.variant.price.amount) }} <span
                    class="text-[12px]">/ item</span>
                </div>
              </div>
              <div>
                <input type="number" v-model="lineItemsTemp[index]" class="w-12 text-center border">
                <div>
                  <button class="font-sfizia mt-2 text-[12px] hover:underline" @click="removeLineItem(lineItem.id)">
                    Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4 border-t  pt-4  text-[18px] text-right">
            {{ totalPrice }}
          </div>
          <div class="text-right mt-10">
            <a class="font-title text-[28px] px-[14px] py-[8px] border uppercase transition border-black hover:bg-yellow hover:text-black"
               :href="checkoutUrl">Checkout</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Client from 'shopify-buy';
import { ref, onMounted, watch, computed } from 'vue';
import { inject } from 'vue'

const emitter = inject('emitter');   // Inject `emitter`

const lineItems = ref(null);
const checkoutUrl = ref(null);
const totalPrice = ref(null);
console.log('in cart');

const client = Client.buildClient({
  domain: "camden-arts-projects.myshopify.com",
  storefrontAccessToken: "c235a42ed21a271b8785f6a5170145a5",
});

const checkoutId = ref(null);
const loading = ref(false);
const showCart = ref(false);
const lineItemsTemp = ref([]);

// add computed property that calculates the total quantity of the line items by summing quantity for each


const totalQuantity = computed(() => {
  return lineItems.value.reduce((total, item) => {
    return total + item.quantity;
  }, 0);
});


let formatCurrency = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP'
});

emitter.on('updateCart', (value) => {   // *Listen* for event
  refreshCart(true);
});


emitter.on('addToCart', (data) => {   // *Listen* for event
  console.log('addToCart');
  console.log(data);

  client.product.fetchAll().then((products) => {
    console.log(products);
  });

  const lineItemsToAdd = [
    {
      variantId: data.variant,
      quantity: 1
    }
  ];

  console.log(checkoutId.value);
// Add an item to the checkout
  client.checkout.addLineItems(checkoutId.value, lineItemsToAdd).then((checkout) => {
    console.log(checkout.lineItems); // Array with one additional line item
    setUpCart(checkout, true);
  });
});


onMounted(() => {
  // refreshCart();
  initializeCart();
});

const refreshCart = (doShowCart) => {
  client.checkout.fetch(checkoutId).then((checkout) => {
    // Do something with the checkout
    setUpCart(checkout);
    if (doShowCart) {
      showCart.value = true;
    }
  });
}

const setUpCart = (checkout, doShowCart) => {
  console.log(checkout);
  checkoutId.value = checkout.id;
  lineItems.value = JSON.parse(JSON.stringify(checkout.lineItems));
  lineItems.value.forEach((item, index) => {
    lineItemsTemp.value[index] = item.quantity;
  });

  checkoutUrl.value = checkout.webUrl;

  totalPrice.value = formatCurrency.format(checkout.totalPriceV2.amount);
  console.log(lineItems.value);
  if (doShowCart) {
    showCart.value = true;
  }
}
const initializeCart = async () => {
  const cartId = localStorage.getItem('shopifyCartId');
  let checkout = null;
  if (cartId) {
    try {
      let checkout = await client.checkout.fetch(cartId);
      console.log(checkout);
      // If the cart is already completed, create a new one
      if (checkout.completedAt) {
        checkout = await createNewCart();
      }
      setUpCart(checkout);
    } catch (error) {
      console.error('Error fetching cart:', error);
      checkout = await createNewCart();
      setUpCart(checkout);
    }
  } else {
    checkout = await createNewCart();
    setUpCart(checkout);
  }

}

const createNewCart = async () => {
  const newCart = await client.checkout.create();
  localStorage.setItem('shopifyCartId', newCart.id);
  return newCart;
};

watch(lineItemsTemp, async (newLineItems, oldLineItems) => {
  console.log(newLineItems);
  loading.value = true;
  let updatedLineItems = [];
  console.log(newLineItems);
  console.log(oldLineItems);
  newLineItems.forEach((quantity, index) => {
    console.log(quantity);
    if (oldLineItems) {
      console.log(oldLineItems[index]);
    }
    if (lineItems.value[index] !== undefined) {
      updatedLineItems.push({
        id: lineItems.value[index].id,
        quantity: quantity
      });
    }
  });

  client.checkout.updateLineItems(checkoutId.value, updatedLineItems).then((checkout) => {
    loading.value = false;
    // totalPrice.value = formatCurrency.format(checkout.totalPriceV2.amount);
    setUpCart(checkout);
    console.log(checkout.webUrl);
  });

}, {deep: true});

// watch(lineItems, async (newLineItems, oldLineItems) => {
//   console.log(newLineItems);
//   loading.value = true;
//   let updatedLineItems = [];
//   console.log(newLineItems);
//   console.log(oldLineItems);
//   newLineItems.forEach((item, index) => {
//     console.log(item.quantity);
//     if (oldLineItems) {
//       console.log(oldLineItems[index].quantity);
//     }
//     updatedLineItems.push({
//       id: item.id,
//       quantity: item.quantity
//     });
//   });
//   client.checkout.updateLineItems(checkoutId.value, updatedLineItems).then((checkout) => {
//     loading.value = false;
//
//     totalPrice.value = formatCurrency.format(checkout.totalPriceV2.amount);
//     console.log(checkout.webUrl);
//   });
//
// }, {deep: true});

const closeCart = (target) => {
  if (target.srcElement.classList.contains('js--cart-wrapper')) {
    showCart.value = false;
  }
}
const removeLineItem = (lineItemId) => {
  console.log('removeLineItem');
  const lineItemIdsToRemove = [lineItemId];

// Add an item to the checkout
  client.checkout.removeLineItems(checkoutId.value, lineItemIdsToRemove).then((checkout) => {
    console.log(checkout.lineItems); // Array with one additional line item
    setUpCart(checkout, true);
  });

}
</script>